<template lang="pug">
label.input-text
  .input-text__label Title <span class="input-text__label-req">*</span> <span class="input-text__label-info">10 chars</span>
  input.input-text__input(
    type="text"
    placeholder=""
    v-model.trim="value"
    @keyup="changeFieldValue()"
  )
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'Title',

  data () {
    return {
      value: ''
    }
  },

  methods: {
    ...mapMutations([
      'changeField'
    ]),

    changeFieldValue () {
      this.changeField({
        name: 'fieldTitle',
        value: this.value
      })
    }
  }
}
</script>
